import React from 'react';
import styles from './style.module.scss';

function GrayContainer({ children, className = "", ...props }) {
    return (
        <div className={`${styles.container} ${className}`} {...props}>
            <div className={styles.innerContainer}>{children}</div>
        </div>
    );
}

export default GrayContainer;
